import { start as startBtaaDetectionEvent } from "./btaa-detection-event";
import { start as startPageviewEvent } from "./pageview-event";
import { start as startRequestEvents } from "./request-events";
export async function start() {
    startBtaaDetectionEvent();
    startPageviewEvent();
    await startRequestEvents();
}
